export default {
  auth: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/layouts/empty.vue").then(m => m.default || m),
  wiki: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/layouts/wiki.vue").then(m => m.default || m)
}